export const uiePathOverview = () => {
  return '/__uie'
}
